import { Column } from 'hatch-components';
import styled from 'styled-components';

export const StyledDrawerBody = styled(Column)(({ theme: { spacing } }) => ({
  flex: 1,
  flexWrap: 'nowrap',
  overflowY: 'auto',
  padding: `${spacing.md} ${spacing.md} 0 ${spacing.md}`,
  width: '100%',
}));
